<template>
  <div id="sac-table-inline-filter">
    <span>ALERTS</span>
    <v-icon
      color="white"
      dark
      :disabled="loading"
      medium
      @click.stop.prevent="handleToggle()"
    >
      mdi-filter-variant
    </v-icon>
    <div
      :class="[
        show ? 'active' : '',
        'filter-header-dropdown',
      ]"
    >
      <div
        v-for="(category) in filters"
        :key="category.value"
        class="filter-text-checkbox"
      >
        <fragment v-if="category.nonSmacAdmin">
          <div>
            {{ category.label }}<span>({{ category.count }})</span>
          </div>
          <input
            :id="category.label"
            type="checkbox"
            :checked="category.active"
            @change="change(category.value, $event.target.checked)"
          >
        </fragment>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SACTableInlineFilter',
  props: {
    filters: Object,
    change: Function,
    profileTab: String,
    loading: Boolean,
  },
  data() {
    return {
      show: false,
    };
  },
  mounted() {
    document.querySelector(':not(.filter-header-dropdown)').addEventListener('click', this.closeOnClick);
  },
  destroyed() {
    document.querySelector(':not(.filter-header-dropdown)').removeEventListener('click', this.closeOnClick);
  },
  methods: {
    handleToggle() {
      this.show = !this.show;
    },
    closeOnClick(e) {
      if (!e.target.closest('.filter-header-dropdown') && this.show) {
        this.show = false;
      }
    },
  },
};
</script>

<style lang="scss">

#sac-table-inline-filter {
  display: grid;
  grid-auto-flow: column;
  align-items: center;
  .filter-header-dropdown {
    display: grid;
    grid-auto-flow: row;
    padding: 12px 0;
    top: 45px;
    right: 5px;
    position: absolute;
    background-color: $WHITE;
    width: 250px;
    box-shadow: 0 1px 27px 12px rgba(9,15,32,0.1);
    border-radius: 6px;
    transition: transform 0.1s ease;
    transform: scaleY(0);
    transform-origin: top;
    color: $BLACK;
    font-size: 14.22px;
    font-weight: 600;
    line-height: 40px;
    &.active {
      transform: scaleY(1);
    }

    &:after {
      content: '';
      position: absolute;
      top: 0;
      right: 15px;
      width: 0;
      height: 0;
      border: 8px solid transparent;
      border-bottom-color: $WHITE;
      border-top: 0;
      margin-left: -8px;
      margin-top: -8px;
    }
    .filter-text-checkbox {
      padding: 0 15px;
      display: grid;
      grid-auto-flow: column;
      justify-content: space-between;
      align-items: center;
      cursor: pointer;
      input[type=checkbox] {
        height: 17px;
        width: 17px;
      }
      &:hover {
        background-color: $NBLUE10;
      }
    }
  }
}
</style>
